<template>
  <vx-card no-shadow title="Amazon S3 Configuration">
      <p class="font-medium w-1/2">
        Amazon S3 is a cloud-based storage system. On a weekly basis, Lexi can copy
        important data to an S3 account owned by you. <a href="#">.</a>
      </p>
      <p class="font-medium w-1/2">
        Note: Your data may be stored on a server outside of your region when
        using Amazon S3. Please check your Amazon S3 account.
      </p>
      <a-form>
        <a-form-item label="Access Key">
          <input class="ant-input">
        </a-form-item>
        <a-form-item label="Secret Key">
          <input class="ant-input">
        </a-form-item>
        <p class="font-semibold mt-5">Key Policy</p>
        <p class="font-medium w-1/3">
          We use your access key and secret key solely to create your escrow
          bucket and to grant access to Clio so we can store your data. Lexi
          does not store your access key or secret key
        </p>
        <div class="flex items-center mt-5">
          <a-button type="primary" size="large" style="border-radius: 3px !important;">
            Save Data Escrow Settings
          </a-button>
          <div class="pl-2">or</div>
          <a-button type="link">
            Cancel
          </a-button>
        </div>
      </a-form>
  </vx-card>
</template>

<script>
    export default {
        name: "Billing"
    }
</script>

<style scoped>

</style>
